import React from 'react';
import './Syles/Design.scss';
import StyledButton from '../../Shared/StyledButton/StyledButton';
import Tilt from 'react-parallax-tilt';

const Design=(props)=>{
    return(
        <div className="design-home">
            <h1>{props.title}</h1>
            <p>{props.desc}</p>
            <div className="btns">
                <StyledButton btn="Request a demo " styles="nobg-btn"/>
                <StyledButton btn="Watch video "/>
            </div>
          

            <div className="image-part" data-aos="zoom-in"
              data-aos-delay={100} 
              style={{ backgroundImage: `url(${props.backgroundImage})` }}
              ></div>
         
        </div>
    )
};
export default Design ;